<template>
	<div class="search-bar">
		<div class="search-area">
			<span class="search-area-hint">校领导</span>
			<input class="search-input nameInput" :value="nameInput" placeholder="请输入" @input="inputSearchName"
				:disabled="disableInputName" />
		</div>
		<div class="search-area">
			<span class="search-area-hint">关键字</span>
			<input class="search-input keywordsInput" :value="keywordsInput" placeholder="请输入"
				@input="inputSearchKeywords" />
		</div>
		<div class="search-area">
			<span class="search-area-hint">时间节点</span>
			<el-date-picker v-model="searchTime" type="datetimerange" start-placeholder="开始日期时间"
				end-placeholder="结束日期时间" format="yyyy-MM-dd HH:mm" :default-time="['08:00:00', '18:00:00']"
				:picker-options="pickerOptions" align="right" :unlink-panels="true">
			</el-date-picker>
		</div>
		<div class="search-bar-btns">
			<div class="search-bar-btns-each btns-submit" @click="searchSchedule">
				<span>提交</span>
			</div>
			<div class="search-bar-btns-each btns-reset" @click="resetSearch">
				<span>重置</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				userInfo: '', //用户信息
				nameInput: '', //搜索输入领导姓名
				disableInputName: false, //是否禁止输入名字
				keywordsInput: '', //搜索输入日程关键字
				searchTime: '', //搜索选择时间范围
				pickerOptions: {
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setHours(0, 0, 0);
							end.setHours(23, 59, 0);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '未来一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}]
				}
			}
		},
		mounted() {
			let that = this;
			that.$nextTick(() => {
				that.$bus.$on('selectViewUser', (userInfo) => {
					that.userInfo = userInfo;
					let loginUserInfo = JSON.parse(localStorage.getItem('userInfo'));
					if (userInfo || loginUserInfo.role == 1 || loginUserInfo.role == 2) {
						that.nameInput = userInfo.name;
						that.disableInputName = true;
					} else {
						that.nameInput = '';
						that.disableInputName = false;
					}
				})
			})
		},
		methods: {
			//输入搜索的领导姓名
			inputSearchName(e) {
				let that = this;
				that.nameInput = e.target.value;
			},
			//输入搜索的日程关键字
			inputSearchKeywords(e) {
				let that = this;
				that.keywordsInput = e.target.value;
			},
			//点击搜索日程
			searchSchedule() {
				let that = this;
				if (!that.nameInput && !that.keywordsInput && !that.searchTime) {
					return;
				}
				let params = {
					name: that.nameInput,
					startTime: that.searchTime ? that.searchTime[0] : '',
					endTime: that.searchTime ? that.searchTime[1] : '',
					describe: that.keywordsInput
				};
				that.$bus.$emit("searchSchedule", JSON.stringify(params));
			},
			//点击重置搜索
			resetSearch() {
				let that = this;
				if (that.userInfo) {
					that.nameInput = that.userInfo.name;
				} else {
					that.nameInput = '';
				}
				that.keywordsInput = '';
				that.searchTime = '';
				let params = {
					name: that.nameInput,
					startTime: that.searchTime ? that.searchTime[0] : '',
					endTime: that.searchTime ? that.searchTime[1] : '',
					describe: that.keywordsInput
				};
				that.$bus.$emit("searchSchedule", JSON.stringify(params));
			}
		},
	}
</script>

<style lang="scss">
	.search-bar {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		background-color: #E8EFFF;

		.search-area {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;

			.search-area-hint {
				flex-shrink: 0;
				font-weight: 400;
				color: #333333;
			}

			.search-input {
				background-color: #EAF1FC;
				border: 1px solid #B0CBFD;
			}
		}

		.search-bar-btns {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-end;

			.search-bar-btns-each {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				cursor: pointer;

				span {
					font-weight: 400;
					color: #FFFFFF;
				}
			}

			.btns-submit {
				background-color: #04BD63;
				border: 1px solid #04BD63;

				span {}
			}

			.btns-reset {
				background-color: #EAF1FC;
				border: 1px solid #B0CBFD;

				span {
					color: #999999;
				}
			}
		}
	}

	@media screen and (min-width: 1024px) {
		.search-bar {
			padding: 12px;

			.search-area {
				.search-area-hint {
					font-size: 14px;
					margin: 0 14px 0 0;
				}

				.search-input {
					height: 38px;
					border-radius: 3px;
					padding: 0 18px;
					font-size: 14px;
				}

				.nameInput {
					width: 50px;
				}

				.keywordsInput {
					width: 100px;
				}

				.el-date-editor .el-range-input {
					font-size: 14px;
				}

				.el-date-editor--datetimerange.el-input,
				.el-date-editor--datetimerange.el-input__inner {
					width: 290px;
				}

				.el-input__inner {
					height: 38px;
					line-height: 38px;
				}

				.el-date-editor .el-range__icon,
				.el-date-editor .el-range__close-icon {
					margin-left: 0;
					font-size: 14px;
					line-height: 30px;
				}

				.el-date-editor .el-range-input {
					width: 100%;
				}

				.el-date-editor .el-range-separator {
					line-height: 30px;
				}
			}

			.search-bar-btns {
				.search-bar-btns-each {
					padding: 10px;
					border-radius: 4px;

					span {
						font-size: 14px;
					}
				}

				.btns-submit {
					span {}
				}

				.btns-reset {
					margin: 0 0 0 13px;

					span {}
				}
			}
		}
	}

	@media screen and (min-width: 1280px) {}

	@media screen and (min-width: 1366px) {}

	@media screen and (min-width: 1440px) {}

	@media screen and (min-width: 1680px) {

		.search-bar {
			padding: 26px;

			.search-area {
				.search-area-hint {
					font-size: 25px;
					margin: 0 20px 0 0;
				}

				.search-input {
					height: 60px;
					border-radius: 5px;
					padding: 0 25px;
					font-size: 25px;
				}

				.nameInput {
					width: 150px;
				}

				.keywordsInput {
					width: 250px;
				}

				.el-date-editor .el-range-input {
					font-size: 25px;
				}

				.el-date-editor--datetimerange.el-input,
				.el-date-editor--datetimerange.el-input__inner {
					width: 520px;
				}

				.el-input__inner {
					height: 60px;
					line-height: 60px;
				}

				.el-date-editor .el-range__icon,
				.el-date-editor .el-range__close-icon {
					margin-left: 0;
					font-size: 25px;
					line-height: 53px;
				}

				.el-date-editor .el-range-input {
					width: 42%;
				}

				.el-date-editor .el-range-separator {
					line-height: 53px;
				}
			}

			.search-bar-btns {
				.search-bar-btns-each {
					padding: 14px;
					border-radius: 7px;

					span {
						font-size: 25px;
					}
				}

				.btns-submit {
					span {}
				}

				.btns-reset {
					margin: 0 0 0 18px;

					span {}
				}
			}
		}
	}

	@media screen and (min-width: 1920px) {}
</style>